import React, { useContext, useEffect, useState } from 'react';
import { Context } from '../../store/AppContext';
import RenderPatenteTabla from './RenderPatenteTabla';
import ModalPatenteSeleccionada from './ModalPatenteSeleccionada';

const PatentesRevisionVencida = ({ onRegresar }) => {
  const { store, actions } = useContext(Context);
  const [modalPatente, setModalPatente] = useState(null);
  const onVista = 'RevisionVencida';
  const patentes = store.patentes || [];

  useEffect(() => {
    actions.getPatentesRevisionVencida();
  }, []);

  const abrirModal = (patente) => {
    actions.getPatente(patente.id);
    setTimeout(() => {
      setModalPatente(store.patente);
    }, 700);
  };

  const actualizarModal = (patenteId) => {
    actions.getPatente(patenteId);
    setTimeout(() => {
      setModalPatente(store.patente);
    }, 700);
  };

  const cerrarModal = () => {
    setModalPatente(null);
  };

  return (
    <div className="grid-container">
      <div className="grid-x grid-padding-x">
        <div className="cell">
          <button className="button" onClick={onRegresar}>Regresar</button>
          <h2>Patentes con revisión vencida</h2>
          <p>
            Patentes con 11 o más días desde la última revisión de estado, que no están Terminadas ni en No Sigue Proceso, y que tienen código o número de expediente.
          </p>
          <h5>
            {patentes.length} patente{patentes.length === 1 ? '' : 's'} encontrada{patentes.length === 1 ? '' : 's'}
          </h5>
          {patentes.length > 0 ? (
            <RenderPatenteTabla
              patentes={patentes}
              onClickFila={abrirModal}
              mostrarFechaCreacion
              mostrarRevisionEstado
            />
          ) : (
            <div className="callout success">
              <h5>No hay patentes con revisión vencida</h5>
              <p>Ningún registro cumple estos criterios en este momento.</p>
            </div>
          )}
          <ModalPatenteSeleccionada
            patente={modalPatente}
            onClose={cerrarModal}
            onUpdate={actualizarModal}
            onVista={onVista}
          />
        </div>
      </div>
    </div>
  );
};

export default PatentesRevisionVencida;
